import React from 'react';
import { useRemainingWidth, useWidth, WidthProvider } from '../width-context';
import { SectionSimple } from './section-simple';
import { SectionFullWidth } from './section-full-width';
export function Section(props) {
    var backgroundColor = props.backgroundColor, borderBottom = props.borderBottom, borderLeft = props.borderLeft, borderRight = props.borderRight, borderTop = props.borderTop, children = props.children, cssClass = props.cssClass, _a = props.direction, direction = _a === void 0 ? 'ltr' : _a, fullWidth = props.fullWidth, _b = props.padding, padding = _b === void 0 ? '20px 0' : _b, _c = props.textAlign, textAlign = _c === void 0 ? 'center' : _c;
    var width = useWidth().width;
    var remainingWidth = useRemainingWidth({
        padding: padding,
        borderLeft: borderLeft,
        borderRight: borderRight,
    });
    var simpleSection = (React.createElement(SectionSimple, { backgroundColor: backgroundColor, borderBottom: borderBottom, borderLeft: borderLeft, borderRight: borderRight, borderTop: borderTop, cssClass: cssClass, direction: direction, padding: padding, textAlign: textAlign, width: width, fullWidth: fullWidth },
        React.createElement(WidthProvider, { value: remainingWidth }, children)));
    if (fullWidth) {
        return (React.createElement(SectionFullWidth, { cssClass: cssClass, backgroundColor: backgroundColor }, simpleSection));
    }
    return simpleSection;
}
//# sourceMappingURL=section.js.map